// config
import { social } from "../../config/sourceShortcuts";

export default {
  computed: {
    dataBarCollection() {
      if (Object.keys(this.data).length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets(),
          databylables: this.getDataByLables()
        };
      }

      return {};
    }
  },
  methods: {
    getDataSets() {
      let dataArr = [
        {
          label: this.$t('feed.analytics.sourceAndGsm.body.social.networks'),
          backgroundColor: "#f38928",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.socialReducer(),
          showLabel: this.showLabel,
          short: 'sc'
        },
        {
          label: this.$t('feed.analytics.sourceAndGsm.body.social.gs'),
          backgroundColor: "#7c17e1",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.gs ? this.data.gs.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: 'gs'
        },
      ];

      if (!this.socialList.includes('gs')) {
        dataArr = dataArr.filter(item => item.short !== 'gs');
      }

      if (this.socialList.includes('gs') && this.socialList.length === 1) {
        dataArr = dataArr.filter(item => item.short !== 'sc');
      }

      return dataArr;
    },
    getLabels() {
      return this.data.total.total.map(item => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;

          return [item[0].slice(-2), this.month[month]];
        }

        return item[0];
      });
    },
    socialReducer() {
      let socials = [];

      const dataEntries = Object.entries(this.data);
      const totalLength = this.data.total.total.length;

      for (let i = 0; i < totalLength; i++) {
        let sum = 0;
        dataEntries.forEach( item => {
          if (Object.keys(social.items).includes(item[0]) && this.socialList.includes(item[0])){
            sum += this.data[item[0]].total[i][1];
          }
        });
        socials.push(sum);
      }

      return socials;
    },
    getDataByLables() {
      return this.data.gs.total.map((item, id) => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;
          return {
            category: item[0].slice(-2) + " " + this.month[month],
            gs: item[1],
            sc: this.data.tg.total[id][1] + this.data.fb.total[id][1] + this.data.ig.total[id][1] + this.data.ok.total[id][1] + this.data.tw.total[id][1] + this.data.yt.total[id][1] + this.data.vk.total[id][1] /* + this.data.dz.total[id][1],*/
          };
        }
        return {
          category: item[0],
          gs: item[1],
          sc: this.data.tg.total[id][1] + this.data.fb.total[id][1] + this.data.ig.total[id][1] + this.data.ok.total[id][1] + this.data.tw.total[id][1] + this.data.yt.total[id][1] + this.data.vk.total[id][1] /* + this.data.dz.total[id][1],*/

        };;
      })
    }
  },
  data() {
    return {
      month: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
      endTime: '23:59:59',
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true,
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.3,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
        },
        legend: {
          display: true,
          position: "top",
          labels: {
            boxWidth: 7,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            anchor: "end",
            color: "#000000",
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: function(value, ctx) {
              if (value === 0) {
                return "";
              }
            },
            align: (ctx) => {
              if (ctx.dataset.data.length) {
                const index = ctx.dataIndex;
                const value = ctx.dataset.data[index];
                const max = ctx.chart.scales['y-axis-0'].max;
                const step = Math.round(max / ctx.dataset.data.length);

                //return value >= (max - step) ? "bottom" : "top";
                return 'top'
              }
            },
            font: {
              weight: 'normal',
              size: 12,
              family: "Roboto",
            },
          },
          clamp: true,
          clip: true,
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
